import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Info, X } from 'lucide-react'

interface HelpBannerProps {
  storageKey: string
  children: React.ReactNode
}

export function HelpBanner({ storageKey, children }: HelpBannerProps) {
  const { t } = useTranslation()
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem(`help-dismissed:${storageKey}`) === '1'
  })

  if (dismissed) {
    return (
      <button
        onClick={() => {
          localStorage.removeItem(`help-dismissed:${storageKey}`)
          setDismissed(false)
        }}
        className="mb-4 flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
      >
        <Info className="h-3.5 w-3.5" />
        <span>{t('showHelp')}</span>
      </button>
    )
  }

  return (
    <div className="mb-6 rounded-lg border border-blue-200 bg-blue-50/50 dark:border-blue-900 dark:bg-blue-950/30 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2.5">
          <Info className="h-4 w-4 text-blue-600 dark:text-blue-400 mt-0.5 shrink-0" />
          <div className="text-sm text-blue-900 dark:text-blue-200 space-y-1.5">
            {children}
          </div>
        </div>
        <button
          onClick={() => {
            localStorage.setItem(`help-dismissed:${storageKey}`, '1')
            setDismissed(true)
          }}
          className="text-blue-400 hover:text-blue-600 dark:hover:text-blue-300 shrink-0"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
